import React from 'react';
import './AdminExamSummary.css';

const AdminExamSummary = () => {
  return (
    <div className="admin-exam-summary">
      <div className="admin-exam-summary-content">
        {/* Add dashboard content here */}
      </div>
    </div>
  );
};

export default AdminExamSummary;
